import { Component, Input, OnInit } from '@angular/core';
import { copyObject } from 'src/modules/shared/utils/utility';
import {AcrBasicInformation, IAcrBasicInformation} from "../../../shared/interfaces/IAcrBasicInformation";

@Component({
  selector: 'app-basic-acr-information-details',
  templateUrl: './basic-acr-information-details.component.html',
  styleUrls: ['./basic-acr-information-details.component.css'],
})
export class BasicAcrInformationDetailsComponent implements OnInit {
  private INITIAL_STATE: IAcrBasicInformation = AcrBasicInformation;

  @Input() Requests: IAcrBasicInformation[] = [];
  @Input() readonly: boolean = true;

  currentRequests: IAcrBasicInformation = this.getInitialState();

  constructor() {}

  ngOnInit(): void {}

  handleAddingNewRecordClick() {
  }

  getInitialState() {
    return copyObject(this.INITIAL_STATE);
  }
}
